import { render, staticRenderFns } from "./WsCard001.vue?vue&type=template&id=4c36aece"
import script from "./WsCard001.vue?vue&type=script&lang=js"
export * from "./WsCard001.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports